/**
 * Real-time multiplayer asteroids game with TypeScript/Bun server and HTML5 Canvas client
 * Lobby domain - React hook for lobby actions
 */

import { joinSpecificLobby } from "../browser";

export const useLobbyActions = () => {
  const joinLobby = (lobbyId: string): boolean => {
    return joinSpecificLobby(lobbyId);
  };

  return { joinLobby };
};
